import { Api } from './client'
import { v3 } from '../../config/api'

export const ApiClient = new Api(v3)
